module.exports = __webpack_public_path__ + "media/dorobek/assets/images/calendar-510b39d70d2af0ae586967cbd7d0e680.svg";